"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var Sentry = __importStar(require("@sentry/browser"));
var AxiosErrorParser_1 = require("Errors/AxiosErrorParser");
var lodash_1 = require("lodash");
var CleanJson_1 = __importDefault(require("CleanJson/CleanJson"));
var ProjectApiService = (function () {
    function ProjectApiService(apiBaseUrl, savingIndicator, notifyUser) {
        var _this = this;
        this.apiBaseUrl = apiBaseUrl;
        this.savingIndicator = savingIndicator;
        this.notifyUser = notifyUser;
        this.getPageStateHistory = function (id) { return __awaiter(_this, void 0, Promise, function () {
            var resp, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, axios_1.default.get("".concat(this.apiBaseUrl, "/projects/").concat(id, "/state-history"), { withCredentials: true })];
                    case 1:
                        resp = _a.sent();
                        return [2, resp.data];
                    case 2:
                        error_1 = _a.sent();
                        Sentry.captureException(error_1);
                        return [2, Promise.reject(error_1)];
                    case 3: return [2];
                }
            });
        }); };
        this.changeOwner = function (projectId, oldOwnerId, newOwnerId) {
            return _this._save("".concat(_this.apiBaseUrl, "/projects/owner"), [
                {
                    oldOwnerId: oldOwnerId,
                    newOwnerId: newOwnerId,
                    projectId: projectId,
                },
            ]);
        };
        this.saveProject = function (id, project) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this._saveProject(id, project)];
                    case 1: return [2, _a.sent()];
                }
            });
        }); };
        this.saveProjectLink = function (id, link) { return __awaiter(_this, void 0, Promise, function () {
            var receipt, oneTimeTokens, password, authenticatedUsers, withoutOmittedProperties;
            return __generator(this, function (_a) {
                receipt = link.receipt, oneTimeTokens = link.oneTimeTokens, password = link.password, authenticatedUsers = link.authenticatedUsers, withoutOmittedProperties = __rest(link, ["receipt", "oneTimeTokens", "password", "authenticatedUsers"]);
                return [2, this._save("".concat(this.apiBaseUrl, "/projects/").concat(id, "/links/").concat(link.secret), (0, CleanJson_1.default)(withoutOmittedProperties))];
            });
        }); };
        this.saveProjectLinkPassword = function (id, link) { return __awaiter(_this, void 0, Promise, function () {
            var receipt, oneTimeTokens, authenticatedUsers, withoutOmittedProperties;
            return __generator(this, function (_a) {
                receipt = link.receipt, oneTimeTokens = link.oneTimeTokens, authenticatedUsers = link.authenticatedUsers, withoutOmittedProperties = __rest(link, ["receipt", "oneTimeTokens", "authenticatedUsers"]);
                return [2, this._save("".concat(this.apiBaseUrl, "/projects/").concat(id, "/links/").concat(link.secret), (0, CleanJson_1.default)(withoutOmittedProperties))];
            });
        }); };
        this.saveIpFilter = function (id, linkSecret, ipFilter) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2, this._save("".concat(this.apiBaseUrl, "/projects/").concat(id, "/links/").concat(linkSecret, "/ipFilter"), { ipFilter: ipFilter })];
            });
        }); };
        this.saveAutoLinkExpiry = function (id, linkSecret, autoLinkExpiry) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2, this._patch("".concat(this.apiBaseUrl, "/projects/").concat(id, "/links/").concat(linkSecret, "/autoLinkExpiry"), { autoLinkExpiry: autoLinkExpiry })];
            });
        }); };
        this.addProjectTag = function (id, projectTag) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this._addProjectTag(id, projectTag)];
                    case 1: return [2, _a.sent()];
                }
            });
        }); };
        this.removeProjectTag = function (id, projectTag) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this._removeProjectTag(id, projectTag)];
                    case 1: return [2, _a.sent()];
                }
            });
        }); };
        this.deleteProjects = function (ids) {
            return _this._delete("".concat(_this.apiBaseUrl, "/projects/bulk"), ids);
        };
        this.restoreProjects = function (ids) {
            return _this._save("".concat(_this.apiBaseUrl, "/projects/bulk-restore"), { data: ids });
        };
        this.restoreProjectsAndArchive = function (ids) {
            return _this._save("".concat(_this.apiBaseUrl, "/projects/bulk-restore/archive"), { data: ids });
        };
        this.restoreProjectsAndSetActive = function (ids) {
            return _this._save("".concat(_this.apiBaseUrl, "/projects/bulk-restore/active"), { data: ids });
        };
        this.setStatus = function (id, pageStatusState) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2, this._save("".concat(this.apiBaseUrl, "/projects/").concat(id, "/status"), {
                        status: pageStatusState.status,
                        subStatus: pageStatusState.subStatus,
                    })];
            });
        }); };
        this.generateCollaboratorHash = function (id) { return __awaiter(_this, void 0, Promise, function () {
            var collaboratorHash;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, axios_1.default.post("".concat(this.apiBaseUrl, "/projects/").concat(id, "/collaboratorHash"), {}, { withCredentials: true })];
                    case 1:
                        collaboratorHash = _a.sent();
                        return [2, collaboratorHash.data];
                }
            });
        }); };
        this.resetCollaboratorHash = function (id) { return __awaiter(_this, void 0, Promise, function () {
            var collaboratorHash;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, axios_1.default.patch("".concat(this.apiBaseUrl, "/projects/").concat(id, "/collaboratorHash"), {}, { withCredentials: true })];
                    case 1:
                        collaboratorHash = _a.sent();
                        return [2, collaboratorHash.data];
                }
            });
        }); };
        this.debounce = function (fn) {
            return (0, lodash_1.debounce)(fn, 1000, { leading: false, trailing: true });
        };
        this._saveProject = function (id, project) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2, this._save("".concat(this.apiBaseUrl, "/projects/").concat(id), (0, CleanJson_1.default)(project))];
            });
        }); };
        this._addProjectTag = function (id, projectTag) { return __awaiter(_this, void 0, Promise, function () {
            var payload;
            return __generator(this, function (_a) {
                payload = {
                    projects: [id],
                    tag: projectTag,
                };
                return [2, this._save("".concat(this.apiBaseUrl, "/projects/tag"), (0, CleanJson_1.default)(payload))];
            });
        }); };
        this._removeProjectTag = function (id, projectTag) { return __awaiter(_this, void 0, Promise, function () {
            var payload;
            return __generator(this, function (_a) {
                payload = {
                    projects: [id],
                    tag: projectTag,
                };
                return [2, this._delete("".concat(this.apiBaseUrl, "/projects/tag"), (0, CleanJson_1.default)(payload))];
            });
        }); };
        this._saveCrmInfo = function (id, crmInfo) {
            return _this._save("".concat(_this.apiBaseUrl, "/projects/").concat(id, "/crminfo"), { crmInfo: crmInfo });
        };
        this._save = function (url, payload) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.runAxiosRequestAndHandleResult(function () { return axios_1.default.post(url, payload, { withCredentials: true }); })];
                    case 1: return [2, _a.sent()];
                }
            });
        }); };
        this._patch = function (url, payload) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.runAxiosRequestAndHandleResult(function () { return axios_1.default.patch(url, payload, { withCredentials: true }); })];
                    case 1: return [2, _a.sent()];
                }
            });
        }); };
        this._delete = function (url, payload) { return __awaiter(_this, void 0, Promise, function () {
            var config;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        config = {
                            data: payload,
                            withCredentials: true,
                        };
                        return [4, this.runAxiosRequestAndHandleResult(function () { return axios_1.default.delete(url, config); })];
                    case 1: return [2, _a.sent()];
                }
            });
        }); };
        this.runAxiosRequestAndHandleResult = function (axiosRequest) { return __awaiter(_this, void 0, void 0, function () {
            var result, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.savingIndicator.saving();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, axiosRequest()];
                    case 2:
                        result = _a.sent();
                        this.savingIndicator.done();
                        return [2, result];
                    case 3:
                        error_2 = _a.sent();
                        this.notifyUser.error((0, AxiosErrorParser_1.getErrorMessage)(error_2));
                        return [2, Promise.reject(error_2)];
                    case 4: return [2];
                }
            });
        }); };
        this.saveProjectWithDebounce = this.debounce(this._saveProject);
        this.saveCrmInfo = this.debounce(this._saveCrmInfo);
    }
    ProjectApiService.prototype.setProjectFolder = function (id, folderId) {
        return this._save("".concat(this.apiBaseUrl, "/projects/").concat(id), { parentFolder: folderId });
    };
    return ProjectApiService;
}());
exports.default = ProjectApiService;
